const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <div className="bg-[#E50C0C26] rounded-[8px] flex items-center p-1.5x">
      <p className="text-red_dark">{message}</p>
    </div>
  );
};

export default ErrorMessage;
